/*
 * @Description: 分享海报--广告弹窗仓库用
 */

import React, { Component } from 'react';
import { Flex, Modal, Toast } from 'antd-mobile';
import './PromoteModalLess.less';
import Config from 'config/Config';
import Util from 'utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.less';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { NavBar } from 'widget';
import { ImgWrap } from 'pubBiz';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
// import QRCode from 'qrcode.react';
import QRCode from 'qrcode';
import html2canvas from 'html2canvas';
import Stores from 'config/Stores';
// import { withTranslation } from 'config/language/context';

@observer
export default class PromoteModal extends Component {
  constructor(props, context) {
    super(props, context);
    const { mode = 'normal', showDefault = false, userInfo, isLY } = this.props;
    this.appStore = { userInfo, isLY };
    this.state = {
      activeIndex: 0,
      posterList: [],
      imgUrl: '',
      isShowCardPicker: false, // 卡号弹窗
      imgHeight: showDefault ? 526 : 700, // 海报图片
      posterWidth: 526, // 海报宽度
      posterHeight: showDefault ? 814 : 988, // 海报高度
      cardSelectContent: {
        value: '',
        label: ''
      },
      mode,
      showDefault
    };
  }

  async componentDidMount() {
    const { isShareCardPosterNo, sharePosterNoList } = this.props;
    if (isShareCardPosterNo && sharePosterNoList && sharePosterNoList.length > 0) {
      const {
        cardCode,
        realName,
        fromTeamShareFlag = 0
      } = (sharePosterNoList && sharePosterNoList[0]) || {};
      this.setState(
        {
          cardSelectContent: {
            value: cardCode || '',
            label: realName || `${' '}${cardCode}` || '',
            fromTeamShareFlag
          }
        },
        () => {
          this.draw(this.props.posterList);
        }
      );
    } else {
      this.draw(this.props.posterList);
    }
  }

  /**
   * 浏览器型号
   */
  getVersion = () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'ios';
    }
    if (/(Android)/i.test(navigator.userAgent)) {
      return 'android';
    }
    if (navigator.userAgent.indexOf('WebKit') > -1) {
      return 'google';
    }
    return 'pc';
  };

  changeUrl = (url) => {
    const returnUrl = url
      .replace('yofoto-test.obs.cn-east-2.myhuaweicloud.com', 'image-test.yofoto.cn')
      .replace('bucket-prod.obs.cn-east-2.myhuaweicloud.com', 'image.yofogo.com')
      .replace('bucket-uat.obs.cn-east-2.myhuaweicloud.com', 'image-uat.yofoto.cn');
    return returnUrl;
  };

  /**
   * 下载二维码
   */
  downloadImg = () => {
    Toast.info('下载中', 1);
    html2canvas(document.getElementById(`poster${this.state.activeIndex}`), {
      scale: 1,
      useCORS: true, // （图片跨域相关）
      allowTaint: true // 允许跨域（图片跨域相关）
    }).then((canvas) => {
      const img = new Image();
      img.src = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.href = img.src;
      a.download = '二维码'; // 图片name
      a.click();
      Toast.info(`'图片已保存'，'发朋友圈请到手机相册选择')}`, 1);
    });
  };

  hideCardModal = () => {
    this.setState({ isShowCardPicker: false });
  };

  // 设置选择卡号
  setShareCardTypeSelect = (item) => {
    Toast.loading('请稍候', 2000);
    this.setState(
      {
        cardSelectContent: item,
        posterList: []
      },
      () => {
        // 重新绘制
        console.log('重新绘制');
        this.draw(this.props.posterList, item);
      }
    );
  };

  base64(url) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function (status, response) {
        console.log('this>>>', status);
        if (status === 200) {
          let blob = response;
          let fileReader = new FileReader();
          fileReader.onloadend = function (e) {
            let result = e.target.result;
            resolve(result);
          };
          fileReader.readAsDataURL(blob);
        }
      };
      xhr.onerror = function () {
        reject();
      };
      xhr.send();
    });
  }

  /**
   * @description 判断增加分享人的参数
   */
  checkAddShareParams(v) {
    try {
      const key = 'bindCardCode';
      const { cardCode } = this.appStore.userInfo || {};
      if (!cardCode || v.indexOf('register') >= 0) {
        return v;
      }
      if (v.indexOf(key) >= 0) {
        return Util.replaceQueryParam(v, key, cardCode) || v;
      }
      return `${v}${v.indexOf('?') >= 0 ? '&' : '?'}${key}=${cardCode}`;
    } catch (error) {
      return v;
    }
  }

  async draw(list, currItem) {
    const { posterList, mode, posterWidth, posterHeight, imgHeight, showDefault } = this.state;
    let { displayName = '', price, description } = this.props.productInfo;
    const { userInfo, isLY } = this.appStore;
    console.log('posterList11', posterList, toJS(list));
    if (posterList.length >= list.length) {
      Toast.hide();
      return;
    }
    setTimeout(() => {
      Toast.hide(); // 强制隐藏加载提示，防止异常错误
    }, 100000);
    const { cardSelectContent } = this.state;
    let cardNum = currItem && currItem.value ? currItem : cardSelectContent; // 当前选中卡号
    console.log('cardNum1', cardNum);
    const { fromTeamShareFlag = 0 } = cardNum || {}; //

    let posterUrl = list[posterList.length].imgUrl;
    const { realName, avatar } = this.appStore.userInfo || {};
    let jumpUrl = !this.props.isCanvas
      ? window.location.href
      : `${window.location.origin}${
          window.location.pathname
          // }#/personal/guide?memberNum=${userInfo.cardCode}&cardCode=${userInfo.cardCode}&shareSaleCardCode=${cardNum.value}${
        }#/register?memberNum=${userInfo.cardCode}&cardCode=${userInfo.cardCode}&fromTeamShareFlag=${fromTeamShareFlag}&shareSaleCardCode=${cardNum.value}${
          sessionStorage.getItem('systemCode') == 'LY' || this.appStore.isLY
            ? '&hideWechatAuthModal=1&systemCode=LY'
            : ''
        }`;
    if (this.props.shareUrlVal) {
      jumpUrl = this.props.shareUrlVal || jumpUrl;
    }
    jumpUrl = this.checkAddShareParams(jumpUrl) || jumpUrl;
    // 创建canvas
    const oCanvas = document.createElement('canvas');
    const context = oCanvas.getContext('2d');
    console.log('jumpUrl', jumpUrl);
    // 将图片资源转成base64
    // Promise.all([this.base64(posterUrl), this.base64(avatar)]).then(res => {
    // 获取图片base64
    // const posterSrc = posterUrl;
    const posterSrc = this.changeUrl(posterUrl);
    let avatarSrc = this.changeUrl(avatar || Config.uploadImgdefault);
    // # 加载底图
    const posterImg = new Image();
    posterImg.setAttribute('crossOrigin', 'Anonymous');
    posterImg.src = posterSrc;

    posterImg.onload = () => {
      // 获取图片尺寸
      const posterW = posterImg.width; // 海报原尺寸宽度
      const posterH = posterImg.height; // 海报原尺寸宽度
      const w = posterWidth; // canvas宽度
      const h = posterHeight; // canvas高度
      const imgW = w; // 缩放后的poster宽度
      const imgH = (w * posterH) / posterW; // 缩放后的poster高度
      const ratio = w / 750;
      const infoW = w; // 分享区域宽度
      let infoH = 238; // 分享区域高度
      let qrSize = 112;
      // 根据图片尺寸设置canvas尺寸
      oCanvas.width = w;
      oCanvas.height = h;
      context.fillStyle = '#FFFFFF';
      context.fillRect(0, 0, posterWidth, posterHeight);
      if (mode == 'fit') {
        // 店铺海报模式
        infoH = 176;
        qrSize = 128;
        // 推荐尺寸：1536 * 2712
        // # 绘制海报
        context.drawImage(posterImg, 0, 0, imgW, imgH);

        // # 背景打底
        if (imgH <= h) {
          context.beginPath();
          context.moveTo(0, imgH);
          context.lineTo(w, imgH);
          context.lineTo(w, h);
          context.lineTo(0, h);
          context.lineTo(0, imgH); // 绘制最后一笔使图像闭合
          context.fillStyle = '#FFFFFF';
          context.fill();
          context.closePath();
          context.restore();
        }
        // # 绘制渐变白框
        context.beginPath();
        context.moveTo(0, h - infoH);
        context.lineTo(w, h - infoH);
        context.lineTo(w, h);
        context.lineTo(0, h);
        context.lineTo(0, h - infoH); // 绘制最后一笔使图像闭合
        context.fillStyle = '#ffffff'; // 白色填充
        context.fill();
        context.closePath();
        context.restore();

        // # 绘制二维码 - 放置在右下角
        QRCode.toDataURL(jumpUrl)
          .then((qrCodeSrc) => {
            console.log('qrCodeSrc', qrCodeSrc);
            const qrCodeImg = new Image();
            qrCodeImg.setAttribute('crossOrigin', 'Anonymous');
            qrCodeImg.src = qrCodeSrc;
            qrCodeImg.onload = () => {
              const padding = (infoH - qrSize) / 2; // 二维码居中间隙
              const x = w - qrSize - padding; // 计算二维码位置x坐标
              const y = h - infoH + padding; // 计算二维码位置y坐标
              // 绘制二维码
              context.drawImage(qrCodeImg, x, y, qrSize, qrSize);
              context.restore();

              // # 绘制头像 - 头像在左上方
              context.save();
              context.beginPath(); // 开始绘制
              const avatarurl_width = 48; // 绘制的头像宽度
              const avatarurl_height = 48; // 绘制的头像高度
              const avatarurl_x = 24; // 绘制的头像在画布上的位置
              const avatarurl_y = h - infoH + (infoH - avatarurl_height) / 2; // 绘制的头像在画布上的位置
              // if (!this.props.isCanvas) {
              context.arc(
                avatarurl_width / 2 + avatarurl_x,
                avatarurl_height / 2 + avatarurl_y,
                avatarurl_width / 2,
                0,
                Math.PI * 2,
                false
              );
              // }
              context.clip();
              const oAvatar = new Image();
              oAvatar.setAttribute('crossOrigin', 'Anonymous');
              // oAvatar.src = 'https://image.yofogo.com:443/image/icon-default.png'
              oAvatar.src = avatarSrc;
              oAvatar.onload = () => {
                context.drawImage(
                  oAvatar,
                  avatarurl_x,
                  avatarurl_y,
                  avatarurl_width,
                  avatarurl_height
                );
                context.restore();

                if (realName) {
                  context.fillStyle = '#333333';
                  context.font = `18px '微软雅黑'`;
                  context.fillText(
                    `${this.renderName(realName)}'向您推荐'}`,
                    88,
                    h - infoH + 56 + 18
                  );
                  context.fillStyle = '#999999';
                  context.font = `18px '微软雅黑'`;
                  context.fillText('长按识别二维码', 88, h - infoH + 92 + 18);
                }

                // 导出
                if (posterList.length < list.length) {
                  console.log(oCanvas, 'oCanvasoCanvasoCanvas');
                  posterList[posterList.length] = oCanvas.toDataURL();
                  this.setState(
                    {
                      posterList
                    },
                    () => {
                      this.draw(list);
                    }
                  );
                }
              };
            };
          })
          .catch((err) => {
            console.log('err>>>', err);
          });
      } else {
        // # 绘制海报
        context.drawImage(posterImg, 0, 0, w, imgHeight);
        // if (!this.props.isCanvas) {
        // # 绘制底部白框
        // context.beginPath();
        // context.moveTo(0, imgHeight);
        // context.lineTo(posterWidth, imgHeight);
        // context.lineTo(posterWidth, posterHeight);
        // context.lineTo(0, posterHeight);
        // context.lineTo(0, imgHeight); // 绘制最后一笔使图像闭合
        // context.fillStyle = '#FFFFFF';
        // context.fill();
        // context.closePath();
        // context.restore();
        // # 绘制商品名称
        if (!this.props.isCanvas) {
          context.fillStyle = '#000000';
          context.font = '24px 微软雅黑 bold';
          context.fillText(displayName.substring(0, 20), 24, imgHeight + 46); //  24 + 22
          if (displayName.length > 20 && displayName.length <= 40) {
            context.fillStyle = '#000000';
            context.font = '24px 微软雅黑 bold';
            context.fillText(displayName.substring(20), 24, imgHeight + 46 + 36);
          } else if (displayName.length > 40) {
            context.fillStyle = '#000000';
            context.font = '24px 微软雅黑 bold';
            context.fillText(`${displayName.substring(20, 37)}...`, 24, imgHeight + 46 + 36); // 697 + 57
          }
          if (!this.props.hiddenPrice) {
            context.font = '32px 微软雅黑 bold';
            const priceList = Util.formatMoney({
              value: price,
              precision: 0,
              showPrefix: false
            }).split('.');
            const pLeft = priceList[0];
            const pRight = priceList[1] || '00';
            const pLeftWight = context.measureText(pLeft).width;
            // # 绘制商品价格
            console.log('displayName.length <= 20', displayName, displayName.length <= 20);

            if (displayName.length <= 20) {
              context.fillStyle = '#DF2041';
              context.font = '24px 微软雅黑';
              context.fillText(Stores.AppMod.currencySymbol, 24, imgHeight + 46 + 46);
              context.fillStyle = '#DF2041';
              context.font = '32px 微软雅黑 bold';
              context.fillText(pLeft, 40, imgHeight + 46 + 46);
              context.font = '24px 微软雅黑 bold';
              if (pRight) {
                context.fillText('.' + pRight, 40 + pLeftWight, imgHeight + 46 + 46);
              }
              // context.fillStyle = '#EEEEEE';
              // context.fillRect(24, imgHeight + 128, 478, 1);
              // context.stroke();
            } else {
              context.fillStyle = '#DF2041';
              context.font = '24px 微软雅黑 bold';
              context.fillText(Stores.AppMod.currencySymbol, 24, imgHeight + 82 + 46);
              context.fillStyle = '#DF2041';
              context.font = '32px 微软雅黑 bold';
              context.fillText(pLeft, 40, imgHeight + 82 + 46);
              if (pRight) {
                context.fillStyle = '#DF2041';
                context.font = '24px 微软雅黑 bold';
                context.fillText('.' + pRight, 40 + pLeftWight, imgHeight + 82 + 46);
              }
            }
          }
          if (description) {
            context.fillStyle = '#999999';
            context.font = '24px 微软雅黑 bold';
            if (displayName.length <= 20) {
              context.fillText(description.substring(0, 20), 24, imgHeight + 46 + 46);
              if (description.length > 20 && description.length <= 40) {
                context.fillStyle = '#999999';
                context.font = '24px 微软雅黑 bold';
                context.fillText(description.substring(20), 24, imgHeight + 46 + 46 + 36);
              } else if (description.length > 20) {
                context.fillStyle = '#999999';
                context.font = '24px 微软雅黑 bold';
                context.fillText(
                  `${description.substring(20, 37)}...`,
                  24,
                  imgHeight + 46 + 46 + 36
                );
              }
            } else {
              context.fillText(description.substring(0, 20), 24, imgHeight + 46 + 46 + 36 - 10);
              if (description.length > 20 && description.length <= 40) {
                context.fillStyle = '#999999';
                context.font = '24px 微软雅黑 bold';
                context.fillText(description.substring(20), 24, imgHeight + 46 + 46 + 36 + 36 - 12);
              } else if (description.length > 20) {
                context.fillStyle = '#999999';
                context.font = '24px 微软雅黑 bold';
                context.fillText(
                  `${description.substring(20, 37)}...`,
                  24,
                  imgHeight + 46 + 46 + 36 + 36 - 12
                );
              }
            }
          }
        }

        // # 绘制二维码 - 放置在右下角
        QRCode.toDataURL(jumpUrl)
          .then((qrCodeSrc) => {
            console.log('qrCodeSrc', qrCodeSrc);
            const qrCodeImg = new Image();
            qrCodeImg.setAttribute('crossOrigin', 'Anonymous');
            qrCodeImg.src = qrCodeSrc;
            qrCodeImg.onload = () => {
              // 比例 = 图片元素宽度/设计图宽度
              // 间距 = 设计图上的间距 * 比例（右侧间距）
              // 尺寸 = 设计图上的尺寸 * 比例
              // 计算x、y值
              const x = 390;
              const y = showDefault ? 678 : 852;
              // 绘制
              // if (!this.props.isCanvas) {
              context.drawImage(qrCodeImg, x, y, qrSize, qrSize);
              // context.fillStyle = '#999999';
              // context.font = `16px '微软雅黑'`;
              // context.fillText('长按识别二维码', 350, 848 + 12);
              // }
              // # 绘制头像 - 头像在左上方
              context.save();
              context.beginPath(); // 开始绘制
              const avatarurl_width = 64; // 绘制的头像宽度
              const avatarurl_height = 64; // 绘制的头像高度
              const avatarurl_x = 24; // 绘制的头像在画布上的位置
              const avatarurl_y = !this.props.isCanvas ? imgHeight + 176 : 697; // 绘制的头像在画布上的位置
              // if (!this.props.isCanvas) {
              context.arc(
                avatarurl_width / 2 + avatarurl_x,
                avatarurl_height / 2 + avatarurl_y,
                avatarurl_width / 2,
                0,
                Math.PI * 2,
                false
              );
              // }
              context.clip();
              const oAvatar = new Image();
              oAvatar.setAttribute('crossOrigin', 'Anonymous');
              // oAvatar.src = 'https://image.yofogo.com:443/image/icon-default.png'
              oAvatar.src = avatarSrc;
              oAvatar.onload = () => {
                context.drawImage(
                  oAvatar,
                  avatarurl_x,
                  avatarurl_y,
                  avatarurl_width,
                  avatarurl_height
                );
                context.restore();

                if (realName) {
                  context.fillStyle = '#333333';
                  context.font = `24px '微软雅黑'`;
                  context.fillText(
                    `${this.renderName(realName)}'向您推荐'}`,
                    112,
                    !this.props.isCanvas ? imgHeight + 166 + 24 : 697 + 24
                  );
                  context.fillStyle = '#666666';
                  context.font = '20px 微软雅黑';
                  context.fillText('有享云商·有精彩·齐分享', 112, imgHeight + 202 + 20);
                  context.fillStyle = '#666666';
                  context.font = '20px 微软雅黑';
                  context.fillText('长按识别二维码购买', 112, imgHeight + 234 + 20);
                } else {
                  context.fillStyle = '#666666';
                  context.font = '20px 微软雅黑';
                  context.fillText('有享云商·有精彩·齐分享', 112, imgHeight + 182 + 20);
                  context.fillStyle = '#666666';
                  context.font = '20px 微软雅黑';
                  context.fillText('长按识别二维码购买', 112, imgHeight + 214 + 20);
                }

                // 导出
                if (posterList.length < list.length) {
                  console.log(oCanvas, 'oCanvasoCanvasoCanvas');
                  posterList[posterList.length] = oCanvas.toDataURL();
                  this.setState(
                    {
                      posterList
                    },
                    () => {
                      this.draw(list);
                    }
                  );
                }
              };
            };
          })
          .catch((err) => {
            console.log('err>>>', err);
          });
      }
    };
  }

  generatePoster(list) {
    const { posterList } = this.state;
    html2canvas(document.getElementById(`poster${posterList.length}`), {
      scale: 1,
      useCORS: true, // （图片跨域相关）
      allowTaint: true // 允许跨域（图片跨域相关）
    }).then((canvas) => {
      posterList.push(canvas.toDataURL('image/jpeg'));
      this.setState(
        {
          posterList
        },
        () => {
          if (posterList.length < list.length) {
            this.generatePoster(list);
          } else {
            posterList.length === list.length && Toast.hide();
          }
        }
      );
    });
  }

  /**
   * 下载按钮
   */
  renderDownload() {
    const isWeChat = Util.isWeiXin();
    const returnValue = this.getVersion();

    return (
      <CommonBtn
        className="save ghost"
        title={
          isWeChat ? '长按图片保存/转发' : returnValue === 'google' ? '保存图片' : '长按图片保存'
        }
        onClick={() => !isWeChat && this.downloadImg()}
      />
    );
  }

  renderName(name) {
    if (!name) return '';
    let realName = name;
    if (name.length > 8) {
      realName = `${name.substring(0, 3)}...${name.substring(name.length - 2)}`;
    }

    return realName;
  }

  renderPoster(item, index, needId) {
    const { realName, avatar } = this.appStore.userInfo || {};

    return (
      <div id={needId ? `poster${index}` : ''} className="poster-content">
        <img className="poster" src={this.state.posterList[index]} />
        {/* <Flex className="tips" align="center">
          <img
            className="avatar"
            src={avatar || Config.uploadImgdefault}
            onLoadEnd={() => {
              console.log(123123);
            }}
          />
          {realName && <span className="name">来自{realName}的分享</span>}
        </Flex> */}
        {/* <img className="real-poster" src={this.state.posterList[index]} /> */}
      </div>
    );
  }

  render() {
    const { posterList, imgUrl, cardSelectContent, posterWidth } = this.state;
    const { isShareCardPosterNo, sharePosterNoList } = this.props;

    return (
      <div>
        <Modal
          wrapClassName="poromote-modal"
          popup
          visible={this.props.visible}
          animationType="slide-up"
          bodyStyle={{
            background: 'transparent'
          }}
          onClose={() => {
            this.props.onClose && this.props.onClose();
          }}>
          <Flex className="content-box" direction="column">
            <div className="poster-nav" style={{ paddingTop: '20px' }}>
              <span
                className="iconfont icon-fanhui"
                style={{
                  fontSize: '44px',
                  color: '#fff',
                  position: 'absolute',
                  left: '20px',
                  top: '20px'
                }}
                onClick={() => {
                  this.props.onClose && this.props.onClose();
                }}
              />
              <span
                style={{
                  fontSize: '40px',
                  color: '#fff'
                }}>{`${this.state.activeIndex + 1}/${this.props.posterList.length}`}</span>
            </div>
            <div className="content-wrap">
              <Swiper
                className="swiper-wrap"
                spaceBetween={-175} // -250
                slidesPerView={1}
                centeredSlides
                onSlideChange={({ activeIndex }) => {
                  this.setState({ activeIndex });
                }}>
                {this.props.posterList.map((item, index) => {
                  return (
                    <SwiperSlide key={index} width={posterWidth}>
                      {this.renderPoster(item, index, true)}
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <Flex className="footer-wrap" justify="center" direction="column">
                {this.renderDownload()}
                <span className="desc">{'您可将图片保存在手机本地相册后分享'}</span>
              </Flex>
            </div>
          </Flex>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/ProductDetail/PromoteModal/AdPromoteModalView.js